import { render, staticRenderFns } from "./FullDatabase.vue?vue&type=template&id=452bc064&"
import script from "./FullDatabase.vue?vue&type=script&lang=js&"
export * from "./FullDatabase.vue?vue&type=script&lang=js&"
import style0 from "./FullDatabase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports